import { useMutation, useQueryClient } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { deleteApplicationDoc } from '../../requests/deleteApplicationDoc';

export const useDeleteApplicationDoc = (
  uuid: string,
  definitionName: string,
) => {
  const queryClient = useQueryClient();
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync: deleteDoc, ...rest } = useMutation({
    mutationFn: (docId: string) =>
      deleteApplicationDoc(constructDelete, uuid, docId, definitionName),
    onSuccess: () => {
      handleSuccess('Deleted');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs'],
      });
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs-uncategorized'],
      });
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs-tab'],
      });
    },
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Delete failed')),
  });

  return { deleteDoc, ...rest };
};
